import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

function AccessibilityPolicy() {
  return (
    <div className="App">
      <TopBar />
      <div style={{ 
        padding: '120px 24px 48px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{ color: '#004080', marginBottom: '32px' }}>Accessibility Policy</h1>
        
        <div style={{ color: '#333', lineHeight: '1.6' }}>
          <section style={{ marginBottom: '32px' }}>
            <p style={{ fontSize: '16px', marginBottom: '24px' }}>
              <strong>Effective Date: September 29, 2025</strong>
            </p>
            <p style={{ marginBottom: '24px' }}>
              Connection Health Care ("we," "our," or "us") is committed to making our web app accessible to everyone, including people with disabilities. We recognize the importance of ensuring that all users can access and benefit from our services.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>1. Accessibility Commitment</h2>
            <p style={{ marginBottom: '16px' }}>
              We strive to provide an inclusive experience and are committed to improving the accessibility of our app. Our goal is to ensure that all users, regardless of ability, can access and navigate our services comfortably and effectively.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>2. Current Accessibility</h2>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}>At present, our app is web-only.</p>
              <p style={{ marginBottom: '16px' }}>
                While we currently do not have formal accessibility features, we plan to implement features such as screen reader support, keyboard navigation, high-contrast modes, and adjustable text sizes in the future.
              </p>
              <p style={{ marginBottom: '8px' }}>
                Our future development roadmap includes making the app mobile-accessible with full accessibility support.
              </p>
            </div>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>3. Continuous Improvement</h2>
            <p style={{ marginBottom: '16px' }}>
              Accessibility is an ongoing effort. We regularly review and improve our app to enhance usability for all users. Our team is committed to following best practices and standards for accessibility.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>4. Feedback</h2>
            <p style={{ marginBottom: '16px' }}>
              In the future, users will be able to provide accessibility-related feedback directly through the app. Currently, users can contact us via email to report any issues or suggest improvements.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>5. Contact Us</h2>
            <p style={{ marginBottom: '8px' }}>
              If you have questions, concerns, or feedback regarding the accessibility of our app, please reach out to us at:
            </p>
            <p style={{ marginTop: '16px' }}>
              <strong>Email:</strong> info@connectionhealth.ca
            </p>
            <p style={{ marginTop: '16px' }}>
              We welcome all feedback and take it seriously to help make our app accessible to everyone.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AccessibilityPolicy;
